import React from 'react';

import './AnchorDashboardHeader.css';


const AnchorDashboardHeader = ({ heading }) => (
  <>
    <div className="anchor-portal-section">
      <div className="container anchor-portal-section__intro">
        <h2 className="anchor-portal-section__title">{heading}</h2>
      </div>
    </div>
    <div className="anchor-portal-base-header" />
  </>
);

export default AnchorDashboardHeader;
